<div class="layout-middle-col">
  <app-page-header i18n="@@networking">Networking</app-page-header>

  <div class="networking-container">
    <p i18n>Click to video call you will be connected randomly</p>
    <button *ngIf="users?.length" class="btn btn-primary" (click)="callRandomUser()" i18n>Start Networking</button>
    <button *ngIf="!users?.length" class="btn btn-primary" [disabled]="true" i18n>Waiting for others...</button>
  </div>
</div>
